// css
import "./404.css";
// others
import $ from "jquery";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

// THIS IS A 404 PAGE

const NotFound = () => {
  //================== 404 page animation ====================
  const parallax = function (e) {
    var windowWidth = $(window).width();
    if (windowWidth < 768) return;
    var halfFieldWidth = $(".parallax").width() / 2,
      halfFieldHeight = $(".parallax").height() / 2,
      fieldPos = $(".parallax").offset(),
      x = e.pageX,
      y = e.pageY - fieldPos.top,
      newX = (x - halfFieldWidth) / 30,
      newY = (y - halfFieldHeight) / 30;
    $('.parallax [class*="wave"]').each(function (index) {
      $(this).css({
        transition: "",
        transform:
          "translate3d(" + index * newX + "px," + index * newY + "px,0px)"
      });
    });
  };

  // ==============================
  const stopParallax = function () {
    $('.parallax [class*="wave"]').css({
      transform: "translate(0px,0px)",
      transition: "all .7s"
    });
    setTimeout(function () {
      $('.parallax [class*="wave"]').css("transition", "");
    }, 700);
  };

  // 
  return (
    <div style={{ position: "relative" }}>
      <div className="button-sec-404">
        <Button component={Link} to="/" variant="contained" color="primary">
          Go Back</Button>
      </div>
      <div className="not-found parallax"
        onMouseMove={parallax}
        onMouseLeave={stopParallax}
      >
        <div className="sky-bg"></div>
        <div className="wave-7"></div>
        <div className="wave-6"></div>
        <div className="wave-island">
          <img src="http://res.cloudinary.com/andrewhani/image/upload/v1524501929/404/island.svg" alt="Island" />
        </div>
        <div className="wave-5"></div>
        <div className="wave-lost wrp">
          <span>4</span>
          <span>0</span>
          <span>4</span>
        </div>

        <div className="wave-4"></div>
        <div className="wave-boat">
          <img className="boat" src="http://res.cloudinary.com/andrewhani/image/upload/v1524501894/404/boat.svg" alt="Boat" />
        </div>
        <div className="wave-3"></div>
        <div className="wave-2"></div>
        <div className="wave-1"></div>
        <div className="wave-message">
          <p>Look like you're lost</p>
          <p>the page you are looking for not avaible!</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
